import { render, staticRenderFns } from "./Weer.vue?vue&type=template&id=479bd950&"
import script from "./Weer.vue?vue&type=script&lang=js&"
export * from "./Weer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports